import { useEffect, useRef } from 'react';
import { useTMASDK } from '@ywwwtseng/tma-react-kit';

export function Avatar({
  style,
  size = 40,
}: {
  style?: React.CSSProperties;
  size?: number;
}) {
  const { avatar, user } = useTMASDK();
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (avatar) {
      const canvas = canvasRef.current;
      if (canvas) {
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext('2d');

        if (ctx) {
          ctx.drawImage(avatar, 0, 0, size, size);
        }
      }
    }
  }, [avatar, size]);

  if (avatar) {
    return (
      <canvas
        className="animate-fade-in border border-border rounded-full"
        ref={canvasRef}
        style={style}
        width={size}
        height={size}
      />
    );
  }

  return (
    <div
      className="animate-fade-in flex items-center justify-center border border-border rounded-full"
      style={{
        width: size,
        height: size,
        ...style,
      }}
    >
      <span className="text-lg font-semibold">{user?.first_name[0] ?? ''}</span>
    </div>
  );
}

export const Account = {
  Avatar,
};
